import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import {
  AppNotifications,
  BannerStatus,
  FORM_MODE,
  RootState,
  SolutionInputModel,
  TCb,
  UploadedImageModel,
  LanguageOutputModel,
  BannerOutputModel,
} from "../../../../../models";
import { BannerService } from "../../../../../services";
import { NotificationActions, AllLanguageListActions } from "../../../../../store/actions";
import BannerFormPresenter from "./BannerForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./BannerForm.type";
import { v4 as uuidv4 } from "uuid";
import { ImageUtil, loadCallback } from "../../../../../utils";
import { withRouter } from "react-router-dom";
import { APP_COLOR } from "../../../../../constants";

class BannerFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,

      displayColorPicker: false,
      currentColor: APP_COLOR.BLUE,

      bannerStatus: {
        status: false,
      },

      bannerPictures: [],
      bannerResponsivePictures: [],
      languageData: this.props.all_language_list.data,
      activeLanguageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
      filter: {
        code: "",
      },
      bannerImage: "",
      bannerDetail: null,
    };
  }

  onChangeLanguage = (languageId: string) => {
    this.setState({
      activeLanguageId: languageId,
    });
  };

  onUploadBanner = (data: UploadedImageModel) => {
    const formData = new FormData();
    formData.append("image", data.file);
    BannerService.uploadImageBanner(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({
            bannerPictures: [
              { id: uuidv4(), src: ImageUtil.buildBannerImgSrc(res.data.data.picture)!, alt: data.alt || "" },
            ],
          });
        } else if (res.status === 413) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: `${res.data.message}. The image size should be smaller than 2MB`,
          });
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload banner image failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload banner image failed" });
      });
  };

  onRemoveBanner = (fileId: string) => {
    const banners = this.state.bannerPictures.filter((p) => p.id !== fileId);
    this.setState({
      bannerPictures: banners,
    });
  };

  onUploadResponsiveBanner = (data: UploadedImageModel) => {
    const formData = new FormData();
    formData.append("image", data.file);
    BannerService.uploadImageBanner(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({
            bannerResponsivePictures: [
              { id: uuidv4(), src: ImageUtil.buildBannerImgSrc(res.data.data.picture)!, alt: data.alt || "" },
            ],
          });
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Upload banner responsive image failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Upload banner responsive image failed",
        });
      });
  };

  onRemoveResponsiveBanner = (fileId: string) => {
    const banners = this.state.bannerResponsivePictures.filter((p) => p.id !== fileId);
    this.setState({
      bannerResponsivePictures: banners,
    });
  };

  onChangeBannerStatus = (status: boolean) => {
    this.setState((prevState) => {
      return {
        bannerStatus: {
          ...prevState.bannerStatus,
          status,
        },
      };
    });
  };

  handleChangeColor = (color) => {
    this.setState({ currentColor: color.hex });
  };

  handleClickColor = () => {
    this.setState({ displayColorPicker: true });
  };

  handleClosePicker = () => {
    setTimeout(() => this.setState({ displayColorPicker: false }), 200);
  };

  onSubmit = (val: any) => {
    if (!this.state.bannerPictures.length) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please upload banner image" });
      return;
    }

    if (!this.state.bannerResponsivePictures.length) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please upload banner responsive image" });
      return;
    }

    if (this.state.bannerPictures === []) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please input banner title" });
      return;
    }

    const banner = this.state.bannerPictures[0];
    const bannerResponsive = this.state.bannerResponsivePictures[0];

    let data: SolutionInputModel[] = [];

    this.state.languageData.forEach((lang) => {
      if (val[`title${lang.id}`]) {
        let dataObj: any = {
          title: val[`title${lang.id}`],
          shortDescription: val[`shortDescription${lang.id}`],
          textColor: this.state.currentColor,
          image: ImageUtil.convertImgServerSrc(banner.src, "banner"),
          imageAlt: banner.alt,
          imageForResponsive: ImageUtil.convertImgServerSrc(bannerResponsive.src, "banner"),
          imageAltForResponsive: bannerResponsive.alt,
          status: this.state.bannerStatus.status ? BannerStatus.ACTIVE : BannerStatus.INACTIVE,
          languageId: lang.id,
        };
        const found = this.state.initData?.find((i) => i.languageId === lang.id) || false;
        this.state.mode !== FORM_MODE.CREATE &&
          found &&
          Object.assign(dataObj, {
            id: this.state.initData?.find((i) => i.languageId === lang.id)?.id,
          });
        // dataObj = _.pickBy(dataObj, (v) => !_.isUndefined(v));
        data.push(dataObj);
      }
    });

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateBanner(data);
    } else {
      this.onUpdateBanner(data);
    }
  };

  onLoadAllLanguageBannerDetail = (bannerCode: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      BannerService.getBanner(bannerCode)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: BannerOutputModel[] = res.data.data;

            data.forEach((item) => {
              const banner = item.image
                ? {
                    id: item.id,
                    src: ImageUtil.buildBannerImgSrc(item.image)!,
                    alt: item.image || "",
                  }
                : undefined;
              const bannerResponsive = item.image
                ? {
                    id: item.id,
                    src: ImageUtil.buildBannerImgSrc(item.image)!,
                    alt: item.image || "",
                  }
                : undefined;

              this.setState({
                bannerPictures: banner ? [banner] : [],
                bannerResponsivePictures: bannerResponsive ? [bannerResponsive] : [],
                bannerStatus: {
                  status: item.status === BannerStatus.ACTIVE,
                },
                currentColor: item.textColor,
              });
            });

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                bannerDetail: data,
                initData: data,
                loading: false,
              },
              () => {
                loadCallback(cb?.success);
              }
            );
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load data failed",
            });
            this.props.history.goBack();
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Load data failed",
          });
        });
    });
  };

  onCreateBanner = (data) => {
    BannerService.createBanner(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create banner success",
          });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create banner failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create banner failed" });
      });
  };

  onUpdateBanner = (data) => {
    BannerService.updateBanner(this.props.bannerCode!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Update banner success",
          });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update banner failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update banner failed" });
      });
  };

  componentDidMount = () => {
    if (this.props.bannerCode) {
      this.onLoadAllLanguageBannerDetail(this.props.bannerCode);
    }
  };

  render() {
    return (
      <BannerFormPresenter
        {...this.props}
        {...this.state}
        handleChangeColor={this.handleChangeColor}
        handleClickColor={this.handleClickColor}
        handleClosePicker={this.handleClosePicker}
        onUploadBanner={this.onUploadBanner}
        onRemoveBanner={this.onRemoveBanner}
        onUploadResponsiveBanner={this.onUploadResponsiveBanner}
        onRemoveResponsiveBanner={this.onRemoveResponsiveBanner}
        onChangeLanguage={this.onChangeLanguage}
        onChangeBannerStatus={this.onChangeBannerStatus}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    })
  )(BannerFormContainer)
);
